import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';

import {
    Typography, Input, Button, Hidden,
} from '@material-ui/core';

export const devbannerHeight = 50;

const styles = theme => ({
    root: {
        padding: theme.spacing(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    banner: {
        width: '100%',
        height: devbannerHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
        borderBottom: theme.youwell.borders.dim,

        '@media print': {
            display: 'none',
        },
    },
    login: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: theme.palette.grey[100],
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 900, // Must be lower than "loading"

        [theme.breakpoints.down('xs')]: {
            height: '150%', // To account for special scrolling on mobile..
            justifyContent: 'flex-start',
        },
    },
    loginBox: {
        background: theme.palette.common.white,
        borderRadius: theme.youwell.shapes.borderRadius,
        padding: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.breakpoints.down('xs')]: {
            marginTop: '50%',
        },
    },
    input: {
        margin: theme.spacing(2, 0),
    },
});


const DEV_LOGIN_KEY = 'ywDL';

class DevelopmentBanner extends React.Component {
    state = {
        pw: '',
    }

    handleChange = name => (event) => {
        this.setState({ [name]: event.target.value });
    }

    login = () => {
        if (this.state.pw === this.props.password) {
            window.localStorage.setItem(DEV_LOGIN_KEY, Date.now());
        }

        this.setState({ pw: '' });
    }

    hasValidLogin = () => (window.localStorage.getItem(DEV_LOGIN_KEY) > (Date.now() - 7 * 24 * 60 * 60 * 1000))
        && (window.localStorage.getItem(DEV_LOGIN_KEY) > this.props.passwordDate)

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.login();
        }
    };

    render() {
        const {
            classes, translate, password, disabled, showBanner,
        } = this.props;

        if (disabled) {
            return null;
        }
        const isOpen = !password || this.hasValidLogin();

        return (
            isOpen ? (
                <>
                    {showBanner && (
                        <div className={classes.banner}>
                            <Hidden xsDown>
                                <Typography variant="h6" color="inherit">
                                    {translate('dev.underDevelopment')}
                                </Typography>
                            </Hidden>
                            <Hidden smUp>
                                <Typography variant="h6" color="inherit">
                                    {translate('dev.underDevelopmentShort')}
                                </Typography>
                            </Hidden>
                        </div>
                    )}
                </>
            ) : (
                <div className={classes.login}>
                    <div className={classes.loginBox}>
                        <Typography variant="h6" color="inherit" gutterBottom>
                            {translate('dev.underDevelopment')}
                        </Typography>
                        <Typography variant="caption" color="inherit">
                            {translate('dev.pleaseLogInToContinue')}
                        </Typography>

                        <Input onChange={this.handleChange('pw')} value={this.state.pw} className={classes.input} onKeyPress={this.handleKeyPress} />

                        <Button onClick={this.login} variant="outlined">
                            {translate('common.ok')}
                        </Button>
                    </div>
                </div>
            )
        );
    }
}

DevelopmentBanner.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    password: PropTypes.string,
    passwordDate: PropTypes.number,
    disabled: PropTypes.bool,
    showBanner: PropTypes.bool,
};

DevelopmentBanner.defaultProps = {
    password: '',
    passwordDate: 0,
    disabled: false,
    showBanner: false,
};


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(DevelopmentBanner));
